import { AxiosResponse } from "axios";
import request_test from "./axios_test";

export const getSlideDataById = (params: {
  id: string;
}): Promise<AxiosResponse<string>> => {
  return request_test.get("/ppt/getInfo", {
    params,
  });
};

export const getTestSlideData = (params: {
  id: string;
}): Promise<AxiosResponse<string>> => {
  return request_test.get("/demo/getData", {
    params,
  });
};

export const getUserPptById = (params: {
  id: string;
}): Promise<AxiosResponse<string>> => {
  return request_test.get("/userPpt/getInfo", {
    params,
  });
};

export const getUserPptSlide = (params: {
  id: string;
  slideIndex: number;
}): Promise<AxiosResponse<string>> => {
  return request_test.get("/userPpt/getSlide", {
    params,
  });
};

export const updatePpt = (data: any) => {
  return request_test.post("/ppt/update", data);
};

export const analyzePpt = (params: { pptUrl: string }) => {
  return request_test.post("/userPpt/analyze?pptUrl=" + params.pptUrl);
};
